<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <div class="row">
        <div class="col">
          <!-- <div class="d-flex align-items-center justify-content-end">
            <date-picker class="date-picker" v-model="time3" range></date-picker>
            <button class="btn glob-btn">Search</button>
          </div> -->
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-8">
          <div class="p-3 border-right">
            <h2 class="main-title">{{ KapitmansCorner.title }}</h2>
            <p class="text-muted">Posted on {{ FormatDate(KapitmansCorner.date) }}</p>
            <table class="table table-bordered stock-reco-card">
              <thead class="stock-reco-header">
                <tr>
                  <th colspan="4" class="text-center">Stock Recommendation</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td class="text-center">
                    Stock
                    <h4 class="stock-label">
                      {{ KapitmansCorner.stockRecommendations.stockSymbol }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Entry Price
                    <h4 class="stock-label">
                      {{ KapitmansCorner.stockRecommendations.entryPrice }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Target Price
                    <h4 class="stock-label">
                      {{ KapitmansCorner.stockRecommendations.targetPrice }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Potential Upside
                    <h4 class="stock-label">
                      {{ KapitmansCorner.stockRecommendations.potentialUpside }}
                    </h4>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="overview">
              <p
                class="text-muted"
                v-html="KapitmansCorner.stockRecommendations.article"
              ></p>
            </div>

            <div v-for="(item, index) in KapitmansCorner.templates" :key="index">
              <div v-if="item.contentType == 'string'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>
              <div v-if="item.contentType == 'date'">
                <p class="text-muted" v-html="FormatDate(item.content)"></p>
              </div>

              <div v-if="item.contentType == 'image'" class="image-umbraco">
                <b-img
                  class="img-thumbnail"
                  :src="'data:image/jpeg;base64,' + item.content"
                  fluid-grow
                  alt="Fluid-grow image"
                ></b-img>
              </div>
              <div class="table table-umbraco" v-if="item.contentType == 'table'">
                <p v-html="item.content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <!-- <TradingStrategies v-show="false" />
      <InvestingStrategies />
      <Footer /> -->
    </div>
  </div>
</template>

<script>
import navHeader from "../../ResearchPages/NavHeader.vue";
// import Footer from "../ResearchPages/Footer";
// import KapitsmanStockReco from "../ResearchPages/KapitmansStockReco.vue";
// import TradingStrategies from "../ResearchPages/TradingStrategies";
// import InvestingStrategies from "../ResearchPages/InvestingStrategies";
import { mapState } from "vuex";
import moment from "moment";

export default {
  components: {
    navHeader,
    // Footer,
    // KapitsmanStockReco,
    // TradingStrategies,
    // InvestingStrategies
  },

  data() {
    return {
      isDataLoaded: false,
      time3: "",
    };
  },

  computed: {
    ...mapState({
      KapitmansCorner: (state) => state.philstocksResearch.fullReport,
    }),
  },
  methods: {
      GoogleAnalytics() {
      this.$gtag.event("KapitmanCorner", { method: "Google" });
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },

    async GetKapitmanContent() {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetHomeContent")
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },

  async mounted() {
    this.GetKapitmanContent();
    this.$store.dispatch("philstocksResearch/GetReportsContent");
  },
};
</script>

<style></style>
